import React from 'react';

type AspectRatioIconProps = {};

function AspectRatioIcon({}: AspectRatioIconProps) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='4' fill='#ECEFFE' />
      <path
        d='M6.16797 15.3333C6.16797 14.8731 6.54107 14.5 7.0013 14.5H13.668C14.1282 14.5 14.5013 14.8731 14.5013 15.3333C14.5013 15.7936 14.1282 16.1667 13.668 16.1667H7.0013C6.54107 16.1667 6.16797 15.7936 6.16797 15.3333Z'
        fill='black'
      />
      <path
        d='M17 11.168C17.4602 11.168 17.8333 11.5411 17.8333 12.0013C17.8333 12.4616 17.4602 12.8346 17 12.8346H10.3333C9.8731 12.8346 9.5 12.4616 9.5 12.0013C9.5 11.5411 9.8731 11.168 10.3333 11.168H17Z'
        fill='black'
      />
      <path
        d='M15.332 15.3333C15.332 14.8731 15.7051 14.5 16.1654 14.5H16.9987C17.4589 14.5 17.832 14.8731 17.832 15.3333C17.832 15.7936 17.4589 16.1667 16.9987 16.1667H16.1654C15.7051 16.1667 15.332 15.7936 15.332 15.3333Z'
        fill='black'
      />
      <path
        d='M7.83464 11.168C8.29487 11.168 8.66797 11.5411 8.66797 12.0013C8.66797 12.4616 8.29487 12.8346 7.83464 12.8346H7.0013C6.54107 12.8346 6.16797 12.4616 6.16797 12.0013C6.16797 11.5411 6.54107 11.168 7.0013 11.168H7.83464Z'
        fill='black'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.33203 4.5C3.95132 4.5 2.83203 5.61929 2.83203 7V17C2.83203 18.3807 3.95132 19.5 5.33203 19.5H18.6654C20.0461 19.5 21.1654 18.3807 21.1654 17V7C21.1654 5.61929 20.0461 4.5 18.6654 4.5H5.33203ZM18.6654 6.16667H5.33203C4.8718 6.16667 4.4987 6.53977 4.4987 7V17C4.4987 17.4602 4.8718 17.8333 5.33203 17.8333H18.6654C19.1256 17.8333 19.4987 17.4602 19.4987 17V7C19.4987 6.53976 19.1256 6.16667 18.6654 6.16667Z'
        fill='black'
      />
    </svg>
  );
}

export default AspectRatioIcon;
